import Fetch from "./fetchUtils"
const rootUrl = "api/config"

export function getConfiguration() {
    return Fetch.get(rootUrl);
}

export function updateConfiguration(params) {
    return Fetch.put(rootUrl, params);
}